export const totalPage = (totalCount, perPageItems) => {
  return totalCount > 0 ? Math.ceil(totalCount / perPageItems) : 0;
};

export const getPaginatedData = (array, page_size, page_number) => {
  return array.slice((page_number - 1) * page_size, page_number * page_size);
}

export const pagePerItems = 10;